const SECTORS = [
  { id: 1, label: 'Mining' },
  { id: 2, label: 'Oil & Gas' }
];

const SECTOR_NAME_MAPPING = {
  mining: 'Mining',
  'oil-gas': 'Oil & Gas'
};

export { SECTORS, SECTOR_NAME_MAPPING };



// WEBPACK FOOTER //
// ./app/constants/common.js